import React, { memo, useMemo } from 'react';
import GeneralImageNew from '@gp/components/GeneralImageNew';
import EllipsisTextBubble from '@gp/components/EllipsisTextBubble';
import Iconfont from '@gp/components/Iconfont';
import InfoBubble from '@gp/components/InfoBubble';
import PlatformIcon from '@gp/components/PlatformIcon';
import { bubbleContent } from './utils/common';
import './index.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';
import NEW_SVG from '@gp/assets/svg/new-sign.svg';
import LinkJump from '@gp/components/LinkJump';
import { getFormatNumPlus, queryJumpable } from '@gp/utils/common';
import { toProjectDetails, toProjectDetailsByGameType } from '@gp/utils/project';

const DEFAULT_PROPS: LiveCardPropsType = {
  category: 'internal',
  data: null,
};

function LiveCard(props: LiveCardPropsType) {
  const { category, data, projects } = props;

  const toDetails = (e: any, isJump = false) => {
    const { id = '', name = '', platform } = data || {};
    const params = {
      id,
      name,
      tab: 'gameDetail',
      platform,
    } as any;
    return toProjectDetailsByGameType(params, e, isJump, projects);
  };

  return (
    <div className="overview-live-card">
      <div className="card-header">
        {data?.is_new && <div className="new-label">NEW</div>}
        <LinkJump url={toDetails(null, false)}>
          <GeneralImageNew
            domain="game"
            width={40}
            height={40}
            style={{ borderRadius: '8px' }}
            src={data?.img_url || ''}
            onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
              if (!queryJumpable(e)) return;
              toDetails?.(e, true);
            }}
          />
        </LinkJump>
        <div className="header-info">
          <LinkJump url={toDetails(null, false)}>
            <div
              className={'hover-link'}
              onClick={(e: React.MouseEvent<Element, MouseEvent>) => {
                if (!queryJumpable(e)) return;
                toDetails?.(e, true);
              }}
            >
              <EllipsisTextBubble
                text={data?.name || '-'}
                className="header-name"
                style={{
                  color: '#000',
                  fontSize: 14,
                }}
                bubbleStyle={{
                  height: 20,
                  lineHeight: '20px',
                }}
              />
            </div>
          </LinkJump>
          <div className="header-sign">
            {data?.genre?.split('|')?.map((t: string, i: number) => {
              return t && i < 5 ? (
                <label key={t} className="game-type-sign">
                  {t || '-'}
                </label>
              ) : null;
            })}
          </div>
        </div>
      </div>
      <div className="card-footer">
        <div className="footer-item">
          <label className="item-title">YTM({data?.ytm_date || '-'}) Revenue($)</label>
          <span className="item-value">{getFormatNumPlus(String(data?.revenue)) || '-'}</span>
        </div>
        <div className="footer-item">
          <label className="item-title">MAU ({data?.mau_date || '-'})</label>
          <div className="platform-group">
            {category === 'internal' ? (
              <>
                {!data?.platform && '-'}
                {data?.platform && (
                  <span className="platform-item">
                    <PlatformIcon
                      platform={data?.platform}
                      isBubble
                      bubbles={{
                        mobile: bubbleContent('mobile'),
                        pc: bubbleContent('pc'),
                        console: bubbleContent('console'),
                      }}
                    />
                    <span className="platform-value">
                      {getFormatNumPlus(data?.mau || '') || '-'}
                    </span>
                  </span>
                )}
              </>
            ) : (
              <>
                {data?.mau_list?.map((t: platFormItemType) => {
                  return (
                    <InfoBubble
                      key={t?.platform}
                      className="globalpedia-modal-font14"
                      theme="dark"
                      DomOrText={
                        <span className="platform-item">
                          <SvgIcon
                            className="platform-item-icon"
                            type={
                              t?.platform == 'console'
                                ? 'game'
                                : t?.platform == 'mobile'
                                ? 'other-icon'
                                : t?.platform == 'pc'
                                ? 'monitor'
                                : ''
                            }
                          />
                          <span className="platform-value">
                            {getFormatNumPlus(t?.value) || '-'}
                          </span>
                        </span>
                      }
                      customBubbleContent={bubbleContent(t?.platform)}
                    />
                  );
                })}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

LiveCard.defaultProps = DEFAULT_PROPS;

export default memo(LiveCard);
